import React from "react";
import premium_card_illustration from "../../assets-admin/lead-response/premium_card_illustration.jpg";
import { FaCrown } from "react-icons/fa6";

const SuperAdminPremiumSubscriptionCard = () => {
  const features = [
    "Unlimited listings + unlimited verified leads",
    'Exclusive "Top Agent Badge" for credibility',
    "Highlighted placement across locality searches",
  ];
  return (
    <div className="rounded-lg  border border-primary/10 shadow-lg flex flex-col  items-center backdrop-blur-lg">
      <div className="flex flex-col p-6">
        <div className="flex flex-col text-center font-poppins pt-4 ">
          <h3 className="text-lg xl:text-xl font-semibold text-[#031722]">
            Get Our Premium Subscription Plan Today!
          </h3>
          <p className="text-xs xl:text-sm text-text-muted tracking-wide my-4">
            Go for premium subscription for better reach and become a Premier
            Agent for a premier Client.
          </p>
        </div>

        <button
          className="flex items-center mb-4 justify-center gap-1.5 md:gap-2 bg-btn-brandRed 
        hover:bg-[#FF6A3D]  
        px-3 md:px-4 lg:px-5 py-1.5 sm:py-2 md:py-2 text-white  font-medium text-sm md:text-sm  shadow-md hover:shadow-lg 
        transform-gpu transition-all duration-100 ease-out rounded-full
        active:scale-[0.97] active:shadow-sm outline-none focus-visible:ring-1
        select-none cursor-pointer"
        >
          <FaCrown size={20} />
          <span>Go For Premium Now !</span>
        </button>

        <div className="space-y-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-xs text-text-secondary"
            >
              <div className="w-5 h-5 rounded-full bg-status-info/20 flex items-center justify-center flex-shrink-0">
                <svg
                  className="w-3 h-3 text-status-info"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Illustration */}
      <div className="mt-4 w-full flex justify-center">
        <img
          src={premium_card_illustration}
          alt="Premium"
          className="w-full h-48 object-cover scale-x-[-1]"
        />
      </div>
    </div>
  );
};

export default SuperAdminPremiumSubscriptionCard;
